import { createSelector } from 'reselect'
const userRoleSelector = state => state.interactiveVideo.role

export default createSelector(
	userRoleSelector,
	userRole => userRole
)
